import { StockUnionType } from 'types/stock'
import { BreadType } from 'types/bread'
import { FirebaseTimestamp } from 'firebase/index'

const addNotifiedTypes = (params: { bread: BreadType; type: StockUnionType }): Promise<void> => {
  const { bread, type } = params
  if (!bread.bread_ref) return Promise.reject()
  const notifiedTypes = bread.notified_types ? [...bread.notified_types, type] : [type]
  const value: Pick<BreadType, 'notified_types' | 'updated_at'> = {
    notified_types: notifiedTypes,
    updated_at: FirebaseTimestamp.now(),
  }
  return bread.bread_ref.update(value)
}

export default addNotifiedTypes
